import { useSelector, useDispatch } from "react-redux";
import DashboardPage from "./Dashboard/DashboardPage";
import WelcomeScreen from "./WelcomeScreen";
import { Box } from "@mui/system";
import { Grow, Typography } from "@mui/material";
import { setIsTogggleDashboard } from "../../../Helpers/dashboardSlice";

export default function LandingPage() {

  const { userData } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const isTogggleDashboard = useSelector((state) => state.dashboard.isTogggleDashboard);
  const currentDate = new Date().toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }) || "";

  return (
    <div style={{ backgroundColor: isTogggleDashboard && '#f5f5f5', padding: '24px', marginTop: '60px' }}>
      {(userData.roleCode !== "SUPADM") && <div style={{ display: 'flex', justifyContent: "space-between", alignItems: "center", margin: "20px 5px" }}>
        <Grow in={true} timeout={800}
          style={{ transformOrigin: '0 0 0', transition: 'all 0.7s ease-in-out' }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', zIndex: 9, position: 'relative', gap: 2 }}>
            <div style={{ position: 'absolute', left: 0 }}>
              <Grow in={isTogggleDashboard} timeout={1200}
                style={{ transformOrigin: '0 0 0', transition: 'all 0.7s ease-in-out' }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 'bold',
                    fontSize: '1.4rem',
                    transition: 'opacity 0.7s ease-in-out, transform 0.5s ease-in-out, width 0.5s ease-in-out',
                    overflow: 'hidden',
                    transform: isTogggleDashboard ? 'translateX(0)' : 'translateX(0px)',
                    opacity: isTogggleDashboard ? 1 : 0,
                    width: isTogggleDashboard ? 'auto' : '0',
                  }}
                >
                  {isTogggleDashboard && 'Dashboard'}
                </Typography>
              </Grow>
            </div>
            <Box
              component="button"
              onClick={() => dispatch(setIsTogggleDashboard(!isTogggleDashboard))}
              sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                width: '65px',
                height: '30px',
                borderRadius: '9999px',
                px: 1,
                transition: 'background-color 0.3s, transform 0.7s ease-in-out',
                transform: isTogggleDashboard ? 'translateX(130px)' : 'translateX(0px)',
                boxShadow: 2,
                background: isTogggleDashboard
                  ? 'linear-gradient(to top, #4ade80, #15803d)'
                  : '#d1d5db',
                border: 'none',
                cursor: 'pointer',
                '&:hover': {
                  opacity: 0.9,
                },
              }}
            >
              <Box
                component="span"
                sx={{
                  fontSize: '0.65rem',
                  fontWeight: 600,
                  transition: 'all 0.3s',
                  color: isTogggleDashboard ? 'white' : '#4b5563',
                  ml: isTogggleDashboard ? 0.6 : 3,
                }}
              >
                {isTogggleDashboard ? 'ON' : 'OFF'}
              </Box>
              <Box
                component="span"
                sx={{
                  position: 'absolute',
                  right: '8px',
                  width: '24px',
                  height: '24px',
                  bgcolor: 'white',
                  borderRadius: '50%',
                  boxShadow: 3,
                  transition: 'transform 0.3s',
                  transform: isTogggleDashboard ? 'translateX(1)' : 'translateX(-28px)',
                }}
              />
            </Box>
          </Box>
        </Grow>
        <Grow in={true} timeout={800}
          style={{ transformOrigin: '0 0 0', transition: 'all 0.5s ease-in-out' }}
        >
          <div style={{ display: 'flex', alignItems: "center", gap: "5px" }}>
            <span style={{
              color: '#21b657ff',
              fontWeight: 600,
              opacity: isTogggleDashboard ? 1 : 0,
              transform: isTogggleDashboard ? 'translateX(0)' : 'translateX(-50px)',
              transition: 'opacity 0.5s ease-in-out, transform 0.5s ease-in-out, width 0.5s ease-in-out',
              width: isTogggleDashboard ? 'auto' : '0',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              marginRight: isTogggleDashboard ? '5px' : '0',
              display: 'inline-block'
            }}>
              Live*
            </span> Date: {currentDate}
          </div>
        </Grow>
      </div>}

      <div style={{ marginTop: '50px' }}>
        {(userData.roleCode !== "SUPADM" && isTogggleDashboard) ? <DashboardPage /> : <WelcomeScreen />}
      </div>
    </div>
  );
}